export enum UserRole {
  SUPERADMIN = 'Superadmin',
  ADMIN = 'Admin',
  USER = 'User',
  MANUFACTURER = 'Manufacturer',
  INSTALLER = 'Installer',
  GUEST = 'Guest'
}
